import React, {useState} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import Tag, { NewTag } from '../../Tags/Tag';
import { useTags } from '../../../Data/Tags';
import AddEditTag from '../../Tags/AddEditTag';
import Loading from '../../Loading';
import { useSession } from '../../Session';

const fallbackValue = [];

const Tags = ({label, name, help, onChange, disabled, validators, hideIfNoTags = false, showAddTag = true}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const {tags, isLoading, refresh} = useTags();
    const [addingTag, setAddingTag] = useState(false);
    const {hasFeature} = useSession();

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const changeVal = (val) => {
        updateField(name, val);
        onChange && onChange(val);
    }

    const addTag = (tag) => {
        changeVal(val => [...(val ?? []), tag]);
    }

    const removeTag = (tag) => {
        changeVal(val => (val ?? []).filter(t => t !== tag));
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    if (tags && tags.length === 0 && hideIfNoTags) {
        return null;
    }

    if (!hasFeature('TAGS')) {
        return <CommonFieldWrapper {...{label, isDisabled: true}}>
            <p className="p-3 text-xs text-muted text-center">
                Tags are not available on your current plan
            </p>
        </CommonFieldWrapper>
    }

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <fieldset>
            <legend className="sr-only">{label}</legend>
            {(value && value.length > 0) && <div className="p-2 flex flex-row flex-wrap gap-2">
                {value.map((tag) => {
                    return <Tag key={tag}
                        tag={tag}
                        onClick={() => removeTag(tag)}
                        icon="XMark"
                        disabled={isDisabled}
                    />
                })}
            </div>}

            {(!value || value.length === 0) && <p className="p-3 text-xs text-muted text-center">
                No tags selected
            </p>}

            <div className="p-2 flex flex-row flex-wrap gap-2 border-t">
                {isLoading && <Loading size="s" inline center />}
                {tags && tags.map((tag, index) => {
                    if (value && value.includes(tag.id)) {
                        return null;
                    }

                    return <Tag key={index}
                        tag={tag.id}
                        onClick={() => addTag(tag.id)}
                        icon="Plus"
                        disabled={isDisabled}
                        muted
                    />
                })}
                {(!isLoading && showAddTag) && <NewTag onClick={() => setAddingTag(true)} disabled={isDisabled} />}
            </div>
        </fieldset>

        <AddEditTag isOpen={addingTag}
            setIsOpen={() => setAddingTag(false)}
            onSave={async (tag) => {
                await refresh();
                addTag(tag.id)
            }}
        />

    </CommonFieldWrapper>
}


export default Tags;
